import React from 'react';
import { makeStyles, Theme, createStyles, Typography, Avatar, Button, TextField, MenuItem } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import { useTranslation } from "react-i18next"


interface InputProps<T> {
    label: string
    value: T
    editable: boolean
    onChange?: (val: T) => void 
    require?: boolean
    placeholder?: string

}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
        }
    }),
);

export function OnelineText(props: InputProps<string>) {

    const classes = useStyles()

    return (
        <div className={classes.root}>
            {
                !props.editable ? 
                <div>
                    <TextField 
                        InputLabelProps={{
                            shrink: true
                        }}
                        InputProps={{
                            disabled: true,
                            readOnly: true,
                            disableUnderline: true,
                            style: {
                                color: "#000"
                            }
                        }}
                        label={props.label} 
                        value={props.value}
                    ></TextField>
                </div> : 
                <div>
                    <TextField 
                        required={ props.require !== null ? props.require : false }
                        label={props.label} 
                        value={props.value}
                        onChange={(e)=>{props.onChange?.(e.target.value)}}
                    ></TextField>
                </div>
            }
        </div>
    )
}

export function IconUpload(props: InputProps<string|undefined>) {
    
    const classes = useStyles()

    return (
        <div className={classes.root}>
        {
            !props.editable ? 
            <div>
                <Typography variant="caption" display="block" style={{color:"#0000008A"}}>
                    {props.label}
                </Typography>
                <Button variant="outlined" disabled style={{border:"1px solid transparent"}}>
                    <Avatar alt="avatar" src={props.value} />
                </Button>
            </div> : 
            <div>
                <Typography variant="caption" display="block" style={{color:"#0000008A"}}>
                    {props.label}
                </Typography>
                <Button variant="outlined" color="primary" onClick={()=>props?.onChange?.(props.value)} >
                    <Avatar alt="avatar" src={props.value} />
                </Button>
            </div>
        }
         
        </div>
    )
}


export function StatusText(props: InputProps<string>) {
    
    const classes = useStyles()
    const [t] = useTranslation()

    const status = [
        {key: "ownSeat", disabled: true},
        {key: "working", disabled: false},
        {key: "busy", disabled: false},
        {key: "leaveSeat", disabled: true},
        {key: "break", disabled: false},
        {key: "meeting", disabled: false},
        {key: "outing", disabled: true},
        {key: "returnHome", disabled: false},
        {key: "vacation", disabled: false},
        {key: "businessTrip", disabled: false},
    ]

    return (
        <div className={classes.root}>
        {
            !props.editable ? 
            <div>
                <TextField 
                    InputLabelProps={{
                        shrink: true
                    }}
                    InputProps={{
                        readOnly: true,
                        disabled: true,
                        disableUnderline: true,
                        style: {
                            color: "#000"
                        }
                    }}       
                    SelectProps={{
                        IconComponent:"span"
                    }}         
                    label={props.label}
                    defaultValue={props.value}
                    select={true}
                    style={{
                        width: "100%"
                    }}>
                        {
                            status.map(s=>(
                                <MenuItem key={s.key} value={s.key} disabled={s.disabled}><Typography>{t(`status.${s.key}`)}</Typography></MenuItem>
                            ))
                        }
                </TextField>
            </div> : 
            <div>
                <TextField   
                    onChange={(e)=>props.onChange?.(e.target.value)}
                    label={props.label}
                    defaultValue={props.value}
                    select={true}
                    style={{
                        width: "100%"
                    }}
                >
                    {
                        status.map(s=>(
                            <MenuItem key={s.key} value={s.key} disabled={s.disabled}><Typography>{t(`status.${s.key}`)}</Typography></MenuItem>
                        ))
                    }
                </TextField>
            </div> 
        }
        </div>
    )
}

export function RatingField(props: InputProps<number>) {
    
    const classes = useStyles()

    return (
        <div className={classes.root}>
        {
            !props.editable ? 
            <div>
                <Typography variant="caption" display="block">
                    {props.label}
                </Typography>
                <Rating
                    readOnly
                    precision={0.5}
                    value={props.value}
                />
            </div> : 
            <div>
                <Typography variant="caption" display="block">
                    {props.label}
                </Typography>
                <Rating
                    onChange={(e,v)=>v && props.onChange?.(v)}
                    precision={0.5}
                    value={props.value}
                />
            </div> 
        }
        </div>
    )
}

